import { FormLabel, Grid } from '@mui/material';
import { useLangFile } from '../../../../../../js/context/LanguageContext';
import { TrackedTextFormControl } from '../../../../Analytics/TrackedComponents';
import { ANALYTICS_EVENTS } from '../../../../Analytics/AnalyticsConstants';
import React, { memo } from 'react';

interface SeedingCalcHybridInputsProps {
  unitsPerSack: number;
  handleUpdateUnitsPerSack: (unitsPerSack: number) => void;
  sackWeight: number;
  handleUpdateSackWeight: (sackWeight: number) => void;
}

const SeedingCalcHybridInputs: React.FC<SeedingCalcHybridInputsProps> = ({
  unitsPerSack,
  handleUpdateUnitsPerSack,
  sackWeight,
  handleUpdateSackWeight,
}: SeedingCalcHybridInputsProps) => {
  const LangFile = useLangFile();

  return (
    <Grid size={5} container spacing={1}>
      <Grid size={6}>
        <FormLabel component="label">
          {LangFile.PrescriptionSettings.seedingCalc.unitsPerSack.title}
        </FormLabel>
        <TrackedTextFormControl
          {...ANALYTICS_EVENTS.textField('seeding_calculator_units_per_sack')}
          variant={'outlined'}
          size={'small'}
          value={unitsPerSack ? unitsPerSack : 0}
          type={'number'}
          margin="dense"
          onUpdate={handleUpdateUnitsPerSack}
          disablePadding={true}
          acceptZero={true}
          min={0}
        />
      </Grid>
      <Grid size={6}>
        <FormLabel component="label">
          {LangFile.PrescriptionSettings.seedingCalc.sackWeight.title}
        </FormLabel>
        <TrackedTextFormControl
          {...ANALYTICS_EVENTS.textField('seeding_calculator_sack_weight')}
          acceptZero={true}
          variant={'outlined'}
          size={'small'}
          margin="dense"
          value={sackWeight ? sackWeight : 0}
          type={'number'}
          endAdornment={'kg'}
          onUpdate={handleUpdateSackWeight}
          disablePadding={true}
          min={0}
        />
      </Grid>
    </Grid>
  );
};

export default memo(SeedingCalcHybridInputs);
